// Maps custom roles to a base "template" role using user.department.
// Mirrors backend/role_templates.py — keep in sync.

const BUILTIN = new Set([
  "admin", "manager", "sales", "telecaller",
  "hr", "junior_hr",
  "factory_manager", "factory_supervisor",
  "infrastructure_dept",
]);

// Order matters — longer/specific keywords first.
const DEPT_TEMPLATE_MAP = [
  ["infrastructure", "infrastructure_dept"],
  ["infra", "infrastructure_dept"],
  ["factory", "factory_manager"],
  ["human resource", "hr"],
  ["hr", "hr"],
  ["sales", "sales"],
  ["marketing", "sales"],
  ["management", "manager"],
  ["operations", "manager"],
  ["admin", "admin"],
  ["it", "admin"],
  ["finance", "manager"],
];

/**
 * Return the user's effective base role.
 * Built-in role → as-is. Custom role → inferred from department.
 */
export function roleTemplate(user) {
  if (!user) return "manager";
  // Backend now sends this directly. Trust it if present.
  if (user.role_template) return user.role_template;
  const role = String(user.role || "").toLowerCase();
  if (BUILTIN.has(role)) return role;
  const dept = String(user.department || "").toLowerCase();
  for (const [keyword, template] of DEPT_TEMPLATE_MAP) {
    if (dept.includes(keyword)) return template;
  }
  return "manager";
}

/**
 * Permission check that respects role templates.
 * Admin always passes. allowedRoles can include built-in role names.
 */
export function userHasRole(user, allowedRoles) {
  if (!user || !Array.isArray(allowedRoles)) return false;
  if (user.role === "admin") return true;
  const template = roleTemplate(user);
  return allowedRoles.includes(template) || allowedRoles.includes(user.role);
}

/**
 * Default landing page after login, by template.
 */
export function defaultLandingPath(user) {
  const t = roleTemplate(user);
  switch (t) {
    case "factory_manager":
    case "factory_supervisor":
      return "/factory";
    case "hr":
    case "junior_hr":
      return "/hr/employees";
    case "infrastructure_dept":
      return "/infrastructure";
    default:
      return "/dashboard";
  }
}
